import { render, staticRenderFns } from "./SplitterForm.vue?vue&type=template&id=2963f3c6&scoped=true"
import script from "./SplitterForm.vue?vue&type=script&lang=js"
export * from "./SplitterForm.vue?vue&type=script&lang=js"
import style0 from "./SplitterForm.vue?vue&type=style&index=0&id=2963f3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963f3c6",
  null
  
)

export default component.exports